<template>
  <SummaryWidget
    :summary="summary"
    :factors="factors"
  />
</template>
  
  <script>
  import SummaryWidget from '@/components/widget/summary/index.vue'
  
  export default {
    name: 'SummaryWidgetPage',
    components: { SummaryWidget },
    data() {
      return {
        summary: "Mattis neque amet sed pulvinar vestibulum bibendum. Nulla lacinia tincidunt id eu nunc. Vitae nec mauris mollis ullamcorper magna molestie. Risus scelerisque leo molestie amet. Eu scelerisque enim ut dictumst.",
        factors: [
          ['+41.00', 'Timely Payments', 'Duis adipiscing convallis condimentum eget. Malesuada sed enim sociis arcu sem eget ultrices tristique. Cursus gravida proin varius est semper.'],
          ['0.00', 'Debt Levels', 'Viverra velit penatibus leo tortor ornare quisque in. Diam fringilla massa etiam lacinia phasellus. Ornare felis dignissim massa nam.']
        ]
      }
    }
  }
  </script>